import React, { useState } from 'react';
import { Button } from "./components/ui/button";
import { Input } from "./components/ui/input";
import { Label } from "./components/ui/label";
import config from './config';

const AdminLogin = ({ onBack, onLoginSuccess }) => {
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleAdminLogin = async () => {
    try {
      setError('');
      const response = await fetch(`${config.API_BASE_URL}/api/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ userId, password }),
      });

      const data = await response.json();

      if (response.ok) {
        if (!data.isAdmin) {
          setError('This account does not have admin privileges');
          return;
        }
        localStorage.setItem('adminToken', data.token);
        onLoginSuccess(); // Call the success handler
      } else {
        setError(data.error || 'Login failed');
      }
    } catch (error) {
      console.error('Login error:', error);
      setError('Login failed. Please try again.');
    }
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    handleAdminLogin();
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-100 to-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-[#406368] mb-2">
            Admin Login
          </h1>
          <p className="text-[#6e6e6d]">
            Please login with your admin credentials
          </p>
        </div>

        <div className="bg-white shadow-xl rounded-lg px-8 py-6 mb-4 border border-gray-100">
          {error && (
            <div className="mb-6 bg-red-50 border-l-4 border-red-500 p-4 rounded">
              <p className="text-red-700 text-sm">{error}</p>
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="space-y-5">
              <div>
                <Label htmlFor="adminUserId">User ID</Label>
                <Input
                  id="adminUserId"
                  type="text"
                  value={userId}
                  onChange={(e) => setUserId(e.target.value)}
                  placeholder="Enter admin user ID"
                />
              </div>

              <div>
                <Label htmlFor="adminPassword">Password</Label>
                <Input
                  id="adminPassword"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter password"
                />
              </div>

              <Button
                type="submit"
                className="w-full bg-[#406368] hover:bg-[#6c8376] text-white"
              >
                Sign In as Admin
              </Button>
            </div>
          </form>
        </div>

        <div className="text-center">
          <Button
            variant="link"
            onClick={onBack}
            className="text-[#6e6e6d] hover:text-[#406368]"
          >
            ← Back to Main App
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;